import { InjectionToken } from '@angular/core';

import { ContactsStore } from '../interfaces';

export const CONTACTS_STORE = new InjectionToken<ContactsStore>('CONTACTS_STORE');
